import React, { useCallback } from 'react';
import { normalizeItem } from '../utils/menuHelpers';

/**
 * A single addon pill (e.g. Ghee, Onion, Egg).
 * @param {{ addon: string|object, variant: 'veg'|'nonveg', onSelect: function }}
 */
const AddonPill = ({ addon, variant = 'veg', onSelect }) => {
  const { name, desc, img } = normalizeItem(addon);

  const handleClick = useCallback(() => {
    onSelect?.({ name, desc, img });
  }, [name, desc, img, onSelect]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick();
      }
    },
    [handleClick]
  );

  return (
    <span
      className={`fm-pill fm-pill--${variant}`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <span className={`fm-pill__dot fm-pill__dot--${variant}`} />
      {name}
      {desc && (
        <span className="fm-pill__tooltip" aria-hidden="true">
          {desc}
        </span>
      )}
    </span>
  );
};

/**
 * A group of addon pills with a label badge.
 */
const AddonGroup = ({ label, addons = [], variant = 'veg', onSelect }) => {
  if (!addons.length) return null;

  return (
    <div className={`fm-addons__group fm-addons__group--${variant}`}>
      <span className={`fm-addons__badge fm-addons__badge--${variant}`}>
        {label}
      </span>
      <div className="fm-addons__pills">
        {addons.map((addon, i) => (
          <AddonPill
            key={i}
            addon={addon}
            variant={variant}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
};

export { AddonPill, AddonGroup };
export default AddonGroup;
